import React from "react";
import { Row, Col } from "react-bootstrap";
import { StyledMap } from "../components";
import { PickupStore } from "../hooks/usePickupStores";
import { useWindowSize } from "../hooks";

interface PickupStoreModalProps {
  preparationDays?: number,
  stores: PickupStore[];
  selectedStore: PickupStore | null;
  setSelectedStore: (store: PickupStore) => void;
}

const modalStyle: React.CSSProperties = {
  fontFamily: "Avenir Next Codensed Regular",
  backgroundColor: "#f6f4f2",
  borderRadius: "12px",
  padding: "20px",
};

const containerStyle: React.CSSProperties = {
  display: "grid",
  padding: "20px 15px",
  border: "1px solid #d3d7da",
  borderRadius: "12px",
  backgroundColor: "#fdfcfb",
  fontFamily: "Avenir Next Codensed Regular",
  color: "rgb(52, 39, 20)",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
  marginBottom: "20px",
  transition: "all 0.3s ease-in-out",
  gap: "10px",
};

const storeItemStyle = (selected: boolean): React.CSSProperties => ({
  padding: "10px 15px",
  backgroundColor: selected ? "rgb(255, 249, 240)" : "rgb(246, 244, 242)",
  borderRadius: "8px",
  marginBottom: "10px",
  cursor: "pointer",
  color: selected ? "rgb(52, 39, 20)" : "rgb(52, 39, 20)",
  borderStyle: "solid",
  borderColor: selected ? "rgb(0, 0, 0)" : "rgb(211, 215, 218)",
  borderWidth: selected ? "1px 1px 4px" : "1px",
  transition: "0.3s",
});

const getNextPickupInfo = (
  openingHours: any,
  preparationDays?: number
): { text: string; isOpen: boolean } => {
  const today = new Date();
  const pickupDate = new Date(today);
  pickupDate.setDate(today.getDate() + (preparationDays ?? 0));

  const pickupDay = pickupDate.getDay(); // 0 = Sonntag, 1 = Montag ...

  const formattedDate = pickupDate.toLocaleDateString("de-DE", {
    weekday: "long",
    day: "2-digit",
    month: "2-digit"
  });

  const periods = openingHours?.periods?.find(
    (period: any) => period.open.day === pickupDay
  );

  const timeStr = periods
    ? `von ${periods.open.time.substring(0, 2)}:${periods.open.time.substring(2)} Uhr bis ${periods.close.time.substring(0, 2)}:${periods.close.time.substring(2)} Uhr`
    : "geschlossen";

  const isOpen = !!periods;

  return {
    text: `${formattedDate} – ${timeStr}`,
    isOpen
  };
};

const PickupStoreModal: React.FC<PickupStoreModalProps> = ({
  preparationDays,
  stores,
  selectedStore,
  setSelectedStore,
}) => {
  const { width } = useWindowSize()
  return (
    <div style={modalStyle}>
      <Row>
        <Col md={4} xs={12} >
          {stores.map((store) => {
            const pickupInfo = getNextPickupInfo(store.opening_hours, preparationDays);
            return (
              <div
                key={store.id}
                style={{ ...containerStyle, ...storeItemStyle(selectedStore?.id === store.id) }}
                onClick={() => setSelectedStore(store)}
              >
                <strong style={{ fontSize: "22px" }}>{store.name}</strong>
                <div>{store.street_address}, {store.postal_code} {store.location}</div>
                <div style={{ fontSize: "1.1rem", fontWeight: 600, color: pickupInfo.isOpen ? "rgb(119, 160, 74)" : "#e53935" }}>
                  {pickupInfo.text}
                </div>
              </div>
            )
          })}
        </Col>
        {width > 450 && (
          <Col md={8} xs={12}>
            <StyledMap stores={stores} selected={selectedStore ?? undefined} />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default PickupStoreModal;
